module.exports = __webpack_public_path__ + "components/Modals/SideDescription/img/szkola.jpg?321f6596";


//////////////////
// WEBPACK FOOTER
// ./components/Modals/SideDescription/img/szkola.jpg
// module id = 2331
// module chunks = 0